import React from "react";
import { Field } from "formik";

import { TransferList } from "../../../../../components/ui";
import { ASSETS_OPTIONS } from "../constants";

interface IProps {
  setFieldValue: (field: string, value: unknown, shouldValidate?: boolean | undefined) => void;
}

const AvailableAssetsTransferList: React.FC<IProps> = ({ setFieldValue }) => (
  <Field
    name="assets"
    component={TransferList}
    leftColumnTitle="Available Assets"
    rightColumnTitle="Selected Assets"
    leftItems={ASSETS_OPTIONS}
    setFieldValue={setFieldValue}
  />
);

export default AvailableAssetsTransferList;
